import { render, staticRenderFns } from "./CategoriaProfissionalListData.vue?vue&type=template&id=bbe4b236&"
import script from "./CategoriaProfissionalListData.vue?vue&type=script&lang=js&"
export * from "./CategoriaProfissionalListData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VCard,VSnackbar})
